let _refreshTokenTimerRef;

export const setRefreshTokenTimerRef = (timerRef) => {
    _refreshTokenTimerRef = timerRef;
    return _refreshTokenTimerRef;
}

export const getRefreshTokenTimerRef = () => {
    return _refreshTokenTimerRef;
}